import { FormControl } from '@chakra-ui/react';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectTalentManager } from '~/selectors/talent-manager';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';
import { TalentDropdown } from './TalentDropdown';

export const ContentSearchFilterMyTalent: React.FC<IContentSearchComponentProps> =
  memo(({ onChange, trackId, order }) => {
    const manager = useSelector(selectTalentManager);
    const isAgencyEnabled = manager?.agency?.enabled;

    return (
      <>
        {isAgencyEnabled && (
          <FormControl
            display="inline-flex"
            width="auto"
            alignItems="center"
            order={order}
            marginRight="auto"
            flexBasis={{ base: '100%', md: 'inherit' }}
          >
            <TalentDropdown onChange={onChange} trackId={trackId} />
          </FormControl>
        )}
      </>
    );
  });
